module.exports = __webpack_public_path__ + "img/videobgc6.7dade1c0.png";